/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  retrieveWorkorderConfigs,
  createWorkorder,
} from '../../state/actions/workorders';

import actions from '../../state/actions';

import SelectLocations from '../../components/SelectLocations';
import WorkorderFormCard from './WorkorderFormCard';
import sortUtils from '../../utils/sort';
import Screen from '../../components/Screen';
import { HistoryType } from '../../types/router';
import { localize } from '../../i18n';

import './WorkorderCreate.css';

class WorkorderCreate extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    this.state = {
      workorderForm: {},
      creating: false,
      showSection: null,
      addedComments: [],
      selectedLocations: [],
    };
  }

  componentWillMount() {
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = this.props;

    if (nextProps.actionType === 'API_CREATED' && nextProps.lastAction.configType === 'workorders') {
      history.push(`/access/workorders/${nextProps.lastAction.id}/details`, { tab: 'comments' });
    }

    if (nextProps.actionType === 'API_CREATE_FAILED' && nextProps.lastAction.configType === 'workorders') {
      this.setState({
        creating: false,
      });
    }
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest();
    }
  }

  toggleSection(showSection, workorderForm) {
    const newState = {
      showSection,
    };
    if (workorderForm) {
      newState.workorderForm = workorderForm;
    }
    this.setState(newState);
  }

  handleSelectLocations(changedLocations) {
    this.setState(Object.assign({}, this.state, {
      selectedLocations: changedLocations,
    }), () => {
      this.toggleSection(null);
    });
  }

  isValidForm(form) {
    let isValid = true;

    // Null due_date is a valid TBD date
    if (form.due_date !== null) {
      // Due date should be bigger than current date
      const dueDate = new Date(form.due_date);
      const currentDate = new Date();
      const isDueDateValid = dueDate.getTime() > currentDate.getTime();

      if (!isDueDateValid) {
        isValid = false;
        this.props.notify(this.props.t('Due date is invalid'));
      }
    }

    return isValid;
  }

  handleOnSubmit(form) {
    // We should validate form just before submitting to cover special cases with dates
    if (this.isValidForm(form)) {
      this.setState({
        creating: true,
      }, () => {
        this.props.createWorkorder(form);
      });
    }
  }

  goBackToList() {
    const { history } = this.props;
    history.push('/access/workorders');
  }

  render() {
    const {
      workorderForm,
      creating,
      showSection,
      selectedLocations,
      addedComments,
    } = this.state;
    const {
      actionType,
      locationsLoaded,
      channels,
      locations,
      workorderConfigs,
      selectedAffiliateInfo,
    } = this.props;

    let workorderCreateDisplay = null;
    if (showSection === 'locations') {
      workorderCreateDisplay = (
        <SelectLocations
          locations={locations}
          selectedLocations={selectedLocations}
          onSelectLocations={changeLocations => this.handleSelectLocations(changeLocations)}
        />
      );
    } else {
      workorderCreateDisplay = (
        <WorkorderFormCard
          actionType={actionType}
          workorderForm={workorderForm}
          locationsLoaded={locationsLoaded}
          channels={channels}
          locations={locations}
          workorderConfigs={workorderConfigs}
          onCancel={() => this.goBackToList()}
          selectedAffiliateInfo={selectedAffiliateInfo}
          selectedLocations={selectedLocations}
          addedComments={addedComments}
          toggleSection={(section, changeWorkorderForm) => this.toggleSection(section, changeWorkorderForm)}
          submittingForm={creating}
          onSubmit={form => this.handleOnSubmit(form)}
        />
      );
    }

    return (
      <Screen title={this.props.t('Work Orders')} helpUrl="#wo">
        <div className="WorkorderCreate">
          <div className="uk-grid uk-flex-center">
            <div className="uk-width-small-4-5 uk-width-mobile-1-1">
              {workorderCreateDisplay}
            </div>
          </div>
        </div>
      </Screen>
    );
  }
}

WorkorderCreate.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  locationsLoaded: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    location_type: PropTypes.string,
    location_name: PropTypes.string,
    location_sort: PropTypes.number,
  })),
  channels: PropTypes.arrayOf(PropTypes.object),
  workorderConfigs: PropTypes.arrayOf(PropTypes.object),
  selectedAffiliateInfo: PropTypes.shape({
    attributes: PropTypes.objectOf(PropTypes.any),
    id: PropTypes.string,
    type: PropTypes.string,
  }),
  history: HistoryType,
  processRequest: PropTypes.func,
  createWorkorder: PropTypes.func,
  notify: PropTypes.func,
  /* eslint-disable */
  lastAction: PropTypes.shape(Object),
  location: PropTypes.string,
  /* eslint-enable */
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  let locations = [];
  let locationTypes = [];
  let workorderConfigs = [];

  const actionType = state.action.type;
  const lastAction = state.api.lastAction;
  let locationsLoaded = false;

  const {
    session: {
      channels: allChannels,
      affiliate: selectedAffiliateInfo,
    },
  } = state;

  const channels = _.filter(allChannels, c => c.type === 'work_order');

  if (state.ticket.work_order_config) {
    workorderConfigs = _.sortBy(_.filter(state.ticket.work_order_config._items, w => w.display), ['work_order_label']);
  }
  if (state.api.location_type) {
    locationTypes = state.api.location_type.data;
  }
  if (locationTypes && state.api.GemsRooms) {
    locations = _.sortBy(_.map(state.api.GemsRooms.data, loc => ({
      id: loc.id,
      location_type: loc.attributes.location_type.kind,
      location_name: loc.attributes.name.toString(),
      location_sort: sortUtils.getStringSortValue(loc.attributes.name),
    })), ['location_sort']);
  }
  if (state.loading.api.locations) {
    locationsLoaded = state.loading.api.locations;
  }

  return {
    locationsLoaded,
    actionType,
    lastAction,
    locations,
    channels,
    workorderConfigs,
    selectedAffiliateInfo,
  };
};

const mapDispatchToProps = dispatch => ({
  processRequest() {
    dispatch(retrieveWorkorderConfigs());
    dispatch(actions.retrieveLocationTypes());
    dispatch(actions.retrieveLocations());
  },
  createWorkorder(payload) {
    dispatch(createWorkorder(payload));
  },
  notify(message) {
    dispatch(actions.showNotification(message, true, {
      type: 'danger',
      location: 'bottom-center',
      showClose: true,
    }));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(WorkorderCreate));



// WEBPACK FOOTER //
// ./src/views/workorders/WorkorderCreate.js